import { TFunction } from 'i18next';
import { AttendanceTotalsReportType } from '../types';

import { saveCSV } from '../../../common';
import { formatHoursFromMinutes } from '../../../helpers/dates';

const COLUMNS = [
  { headerKey: 'attendance.list.studentColumn', dataKey: 'studentName' },
  { headerKey: 'attendance.totalsTable.roomColumn', dataKey: 'roomName' },
  { headerKey: 'attendance.totalsTable.daysPresentColumn', dataKey: 'daysPresent' },
  { headerKey: 'attendance.totalsTable.daysAbsentColumn', dataKey: 'daysAbsent' },
  { headerKey: 'attendance.totalsTable.totalHoursColumn', dataKey: 'totalMinutesAttended' },
];
export function generateAttendanceTotalsCSV(attendanceTotalsReport: AttendanceTotalsReportType, t: TFunction) {
  const { items: attendanceTotals, endDate, startDate } = attendanceTotalsReport;
  const filename = t('attendance.export.totalsFileName', { startDate, endDate });

  const headers = COLUMNS.map((column) => t(column.headerKey)).join(',') + '\n';
  const body = attendanceTotals
    .map((row) => {
      return [
        row.studentName,
        row.roomName,
        row.daysPresent,
        row.daysAbsent,
        formatHoursFromMinutes(row.totalMinutesAttended),
      ].join(',');
    })
    .join('\n');
  const csv = headers + body;
  saveCSV(csv, filename);
}
